import { averageScore } from './averageScore'

/** The two pillars as the one score a tab or summary badge carries. A pillar with no data drops
 *  out of the average rather than nulling the pair, so a pillar that *did* score still reaches the
 *  badge; `null` only when neither scored. The badges turn that into a 0 — see `toBadgeScore`. */
export const getOverallScore = (financial: number | null, sob: number | null): number | null =>
  averageScore([financial, sob])
